import { Box } from "@mui/material"
import { PoweredBy } from "components/PoweredBy/PoweredBy"
import LanguageMenu from "./LanguageMenu"
import { useTranslation } from "react-i18next"
import { STATICS } from "api/api"
import {ReactComponent as EstateToolLogo} from '/src/assets/svg/estatetool-logo.svg'
import { useBreak } from "hooks/useBreak"

export const InactivePage = () => {
    const { i18n, i18n: { language } } = useTranslation()
    const isDesktop                         = useBreak("md_up");

    return <Box sx={{ height: "100%" }}>
        <Box sx={{ pt: { xs:2, lg: 5 }, px: { xs:2, lg: 5 }, height: { xs: "calc(100% - 50px)", lg: "calc(100% - 120px)" }, }}>
            <Box sx={{ display: 'flex', alignContent: 'center', justifyContent: "space-between" }}>
           
                <Box sx={{ height: { xs: 50, lg: 109 }, width: { xs: 100, lg: 229 } }}>
                <EstateToolLogo style={{ width: '100%', height: '100%' }} />
                </Box>
                <Box sx={{ position: 'relative', height: '100%'}}>
                 <LanguageMenu />
                </Box>
            </Box>
            <Box sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', height: "100%", justifyContent: "space-between", pt: { xs:3, lg: 0 } }}>
                <Box  sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', gap: '40px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Box
                            component="img"
                            alt="The house from the offer."
                            src={`${STATICS}/svg/development-image.svg`}
                            sx={{
                                width: '750px',
                            }}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', textAlign: 'center', gap: '16px' }}>
                        <div className={isDesktop ? 'h1' : `h3`}>{ inactivePage.desc[language] }</div>
                        <Box className="paragraph1-regular" sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', textAlign: 'center', gap: '30px', maxWidth: "770px", alignSelf: 'center' }}>
                            <p>{ inactivePage.p1[language] }</p>
                            <p>{ inactivePage.p2[language] }</p>
                        </Box>
                    </Box>
                </Box>
                <PoweredBy />
            </Box>
        </Box>
    </Box>
}



const inactivePage = {
    desc: {
        "en": "The property selector is currently not active.",
        "da": "Boligvælgeren er i øjeblikket ikke aktiv"
    },
    p1: {
        "en": "Unfortunately, this property selector is not available right now. This may be because it is temporarily disabled or no longer in use.",
        "da": "Denne boligvælger er desværre ikke tilgængelig lige nu. Det kan skyldes, at den er midlertidigt deaktiveret, eller at den ikke længere er i brug."
    },
    p2: {
        "en": "If you believe an error has occurred, please contact Estatetool at support@estatetool.dk.",
        "da": "Hvis du mener der er sket en fejl er du velkommen til at kontakte Estatetool på support@estatetool.dk"
    }
}